import React, { useEffect, useState } from 'react';
import { Modal } from '../common/Modal';
import { detectWallets, isMobile, isInWalletBrowser } from '../../utils/wallet';
import { useWeb3 } from '../../context/Web3Context';
import { useNotify } from '../../context/NotificationContext';

export const WalletModal = ({ open, onClose }) => {
  const { connect, connecting } = useWeb3();
  const notify = useNotify();
  const [wallets, setWallets] = useState([]);

  useEffect(() => {
    if (!open) return;
    setWallets(detectWallets());
  }, [open]);

  const handleConnect = async (walletProvider) => {
    const ok = await connect(walletProvider);
    if (ok) onClose && onClose();
  };

  const openInTrust = () => {
    const url = 'https://link.trustwallet.com/open_url?coin_id=20000714&url=' + encodeURIComponent(window.location.href);
    window.location.href = url;
  };

  const openInMetaMask = () => {
    const host = window.location.host + window.location.pathname + window.location.search;
    window.location.href = 'https://metamask.app.link/dapp/' + host;
  };

  return (
    <Modal open={open} onClose={onClose} title="Connect Wallet">
      {wallets.length === 0 && (
        <>
          <div className="alert alert-warning">
            <div className="alert-icon">👛</div>
            <div>
              No wallet detected in this browser.
              {isMobile() && !isInWalletBrowser() && (
                <div style={{ marginTop: 8, fontSize: 13, color: 'var(--text-secondary)' }}>
                  Open this page inside your wallet's built-in browser.
                </div>
              )}
            </div>
          </div>

          {isMobile() && (
            <div className="wallet-list mt-16">
              <button className="wallet-option" onClick={openInTrust}>
                <span className="icon">🛡️</span>
                <span className="name">Open in Trust Wallet</span>
              </button>
              <button className="wallet-option" onClick={openInMetaMask}>
                <span className="icon">🦊</span>
                <span className="name">Open in MetaMask</span>
              </button>
            </div>
          )}
        </>
      )}

      {wallets.length > 0 && (
        <div className="wallet-list">
          {wallets.map((w, i) => (
            <button
              key={i}
              className="wallet-option"
              disabled={connecting}
              onClick={() => handleConnect(w.provider)}
            >
              <span className="icon">{w.icon}</span>
              <span className="name">{w.name}</span>
              {connecting && <span className="btn-spinner" style={{ marginLeft: 'auto' }} />}
            </button>
          ))}
        </div>
      )}

      <div style={{ marginTop: 20, fontSize: 12, color: 'var(--text-tertiary)', textAlign: 'center' }}>
        By connecting, you agree to interact with the smart contract on-chain.
      </div>
    </Modal>
  );
};
